import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const getUserRoles = async ({queryKey}) => {
  const {role_type, access_token, token_type} = queryKey[1];
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/roles/?role_type=${role_type}`,
    method: "POST",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const fetchUsers = async ({queryKey}) => {
  const {access_token, token_type} = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/user/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  return response.data;
}

export const createUser = async ({user ,access_token, token_type}) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/user/`,
    method: "POST",
    data: user,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  return response.data;
}

export const getRoleOrgs = async ({queryKey}) => {
  const {access_token, token_type} = queryKey[1];
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const getRoleProjs = async ({queryKey}) => {
  const {access_token, token_type} = queryKey[1];
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/project/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const fetchUserData = async (data) => {
  const {selectedUser, access_token, token_type} = data;

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/user/${selectedUser["User ID"]}`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const updateUser = async ({selectedUser, payload, access_token, token_type}) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/user/${selectedUser["User ID"]}/`,
    method: "POST",
    data: payload,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    }
  }); 

  return response.data;
}
export const updateDefaultProjOrg = async (data) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/user/update_default_proj_org`,
    method: "POST",
    headers: {
      'Authorization': `${data?.token_type} ${data?.access_token}`
    },
    data : {
      default_org_id : data.default_org_id,
      default_proj_id: data.default_proj_id
    }
  }); 

  return response.data;
}



export const fetchUserOrgProjects = async ({queryKey}) => {
  const {orgId, access_token, token_type} = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/projects/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
    params: {
      org_id_list: orgId.org_id_list,
      roles: orgId.roles
    }
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }
  
  return response.data;
}